import { StepInput } from "../model/StepInput";
import axiosInstance from "../network/AxiosInstance";

const endpoint = process.env.REACT_APP_FACADE_ENDPOINT + "stepinput";

export async function fetchStepInput(
    partitionKey: string,
    rangeKey: string
): Promise<StepInput> {
    return axiosInstance
        .post(`${endpoint}?action=fetch`, {
            'partition_key': partitionKey,
            'range_key': rangeKey
        })
        .then((result) => {
            return result.data
        });
}